import { render, staticRenderFns } from "./BlogDesktop.vue?vue&type=template&id=23552e41&scoped=true"
import script from "./BlogDesktop.vue?vue&type=script&lang=js"
export * from "./BlogDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23552e41",
  null
  
)

export default component.exports